module.exports = {

  title: '',

  /**
   * @type {boolean} true | false
   * @description Whether fix the header
   */
  fixedHeader: false,
  tagsView: true,
  /**
   * @type {boolean} true | false
   * @description Whether show the logo in sidebar
   */
  sidebarLogo: true
}
